import React from "react";
import { useDispatch } from "react-redux";
import { updateServiceRequest } from "../../redux/action";

function TableSettingCard({res, onEdit, onDelete }) {
    const dispatch = useDispatch();

    const handleServe = (requestId) => {
        const dto = { requestId: requestId, statusId: 1 };
        dispatch(updateServiceRequest(dto));
    };

    return (
        <li className="reservation-card">
            <div className="card-header">              
              <p><strong>🪑</strong> {"T-" + res.tableName}</p>
              <div className="row">                       
                        <p><strong>👥</strong>{res.capacity || 0}</p>
                    </div>
            </div>
            
            <div className="card-content">
                <div className="card-body">
                   
                    
                </div>
                
                {/* Fixed the logic block with curly braces and proper ternary */}
                
                    <div>
                        <button className="serve-btn" onClick={onEdit}>
                           ✎ Edit
                        </button>
                        <button className="cancel-btn" onClick={onDelete}>
                           ✖ Delete
                        </button>
                    </div>
              
            </div>
        </li>
    );
}

export default TableSettingCard;